import { render } from "./ProductsViewed.vue?vue&type=template&id=b72c57c0&scoped=true"
import script from "./ProductsViewed.vue?vue&type=script&lang=js"
export * from "./ProductsViewed.vue?vue&type=script&lang=js"

import "./ProductsViewed.vue?vue&type=style&index=0&id=b72c57c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72c57c0"]])

export default __exports__